import KiccEasyCardApi from '@apis/easyCard/KiccEasyCardApi';
import kiccEasyCardQueries from '@apis/queries/kiccEasyCardQueries';
import useLoading from '@hooks/ui/useLoading';
import { useFlow } from '@stackflow/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useUpdateEasyCardName(cardId: string) {
    const { t } = useTranslation('easyCard');
    const queryClient = useQueryClient();
    const { startLoading, stopLoading } = useLoading();
    const { pop } = useFlow();
    const { mutate } = useMutation({
        mutationFn: (cardName: string) => KiccEasyCardApi.updateCardName(cardId, { cardName }),
        onMutate() {
            startLoading();
        },
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: kiccEasyCardQueries._def });
            toast.success(t('rename.success'));
            pop();
        },
        onError(e) {
            console.error(e);
            toast.error(t('rename.error'));
        },
        onSettled() {
            stopLoading();
        },
    });

    const handleUpdateCardName = (cardName: string) => {
        mutate(cardName);
    };

    return {
        handleUpdateCardName,
    };
}

export default useUpdateEasyCardName;
